import React, { ChangeEvent, useCallback, useMemo } from "react";
import { TextInput } from "react-native";

import { FormControlProps } from "./FormBuilder.types";
// import { CheckboxControl } from "./components/CheckBoxControl";
// import { DateControl } from "./components/DateControl";
import { InputControl } from "./components/InputControl";
import { PasswordControl } from "./components/PasswordControl";
import { DateControl } from "./components/DateControl";
import { SelectControl } from "./components/SelectControl";
import { CheckboxControl } from "./components/CheckBoxControl";
import { RadioButtonControl } from "./components/RadioButtonControl";
// import { SelectControl } from "./components/SelectControl";
// import { TextAreaControl } from "./components/TextAreaControl";

export interface IOption<T> {
  label: string;
  value: T;
}

export const FormControl = React.forwardRef<any, FormControlProps<any, any>>(
  (
    {
      control,
      isTouched,
      isSubmitted,
      error,
      value,
      onChange,
      formState,
      label,
      onSubmitEditing,
    }: FormControlProps<any, any>,
    ref: React.Ref<TextInput>
  ) => {
    const getValidationClassName = useCallback(() => {
      if (error && isTouched && isSubmitted)
        return { classes: control?.invalidClassNames || ["isInvalid"], state: "danger" as const };
      if (!error && isTouched && value && isSubmitted)
        return { classes: control?.validClassNames || [], state: "success" as const };
      return { classes: [], state: undefined };
    }, [error, isTouched, isSubmitted, value]);

    const inputError = useMemo(() => {
      if (error && isTouched && isSubmitted) return error;
      return "";
    }, [error, isTouched, isSubmitted]);

    function onInputChange(value: string) {
      onChange(value);
    }

    function onSelectChange(event: ChangeEvent<HTMLSelectElement>) {
      const value = event.target.value;
      onChange(value);
    }

    function onDateChange(value: Date | null) {
      onChange(value);
    }

    function onCheckedChange(event: ChangeEvent<HTMLInputElement>) {
      const value = event.target.checked;
      onChange(value);
    }

    function onRadioChange(event: ChangeEvent<HTMLInputElement>) {
      const value = event.target.value;
      onChange(value);
    }

    function renderControl() {
      switch (control.type) {
        case "input":
          return (
            <InputControl
              {...{
                getValidationClassName,
                onInputChange,
                control,
                formState,
                value,
                error: inputError,
                label,
                required: control.required,
                onSubmitEditing,
              }}
              ref={ref}
            />
          );
        case "textarea":
          return <></>;
        // return <TextAreaControl {...{ getValidationClassName, onInputChange, control, formState, value, error }} />;
        case "password":
          return (
            <PasswordControl
              {...{
                getValidationClassName,
                onInputChange,
                control,
                formState,
                value,
                error: inputError,
                label,
                required: control.required,
                onSubmitEditing,
              }}
              ref={ref}
            />
          );
        case "select":
          return (
            <SelectControl
              {...{
                getValidationClassName: () => getValidationClassName().classes,
                onSelectChange,
                control,
                formState,
                value,
                error,
              }}
            />
          );
        case "date":
          return (
            <DateControl
              {...{
                getValidationClassName,
                onDateChange,
                control,
                formState,
                value,
                error: inputError,
                label,
                required: control.required,
                props: control.props as any,
              }}
            />
          );
        case "checkbox":
          return (
            <CheckboxControl
              {...{
                getValidationClassName: () => getValidationClassName().classes,
                onCheckedChange,
                control,
                formState,
                value,
                error,
              }}
            />
          );
        case "radio":
          return (
            <RadioButtonControl
              {...{
                getValidationClassName: () => getValidationClassName().classes,
                onRadioChange,
                control,
                formState,
                value,
                error,
              }}
            />
          );
        case "hidden":
          return <></>;

        default:
          console.warn("Unsupported data type! Please consider adding custom FormControl");
          return <></>;
      }
    }
    return renderControl();
  }
);
